<template>
  <div class="bank-selection-flow">
    <template v-if="!sourceName">
      <riseup-header/>
      <bank-selection :on-selection="bankSelection"/>
    </template>
    <template v-else>
      <discount-flow v-if="isDiscountSource"/>
      <bank-connection-flow v-else/>
    </template>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
import Segment from '../../../../../../Segment';
import BankSelection from './BankSelection.vue';
import BankConnectionFlow from './BankConnectionFlow.vue';
import RiseupHeader from '../../../../../../base-components/app-header/RiseupHeader.vue';
import DiscountFlow from './DiscountFlow.vue';
import UnsupportedBankPopup from '../../../../../../base-components/onboarding/UnsupportedBankPopup.vue';
import ModalBus from '../../../../../../event-bus/modal-bus';
import sourcesFields from '../../../../../../constants/sourcesFields';

export default {
  name: 'BankSelectionFlow',
  components: {
    BankConnectionFlow,
    BankSelection,
    RiseupHeader,
    DiscountFlow,
  },
  async created() {
    Segment.trackUserGot('BankSelectionEntered');
  },
  computed: {
    ...mapState('onboardingState', ['isLoading', 'pageParams']),
    ...mapGetters('onboardingState', ['invalidCredentials', 'sourceName']),
    isDiscountSource() {
      return _.includes(['דיסקונט ישיר', 'דיסקונט בסיס', 'דיסקונט'], this.sourceName);
    },
  },
  methods: {
    ...mapMutations('onboardingState', ['setPageParams']),
    bankSelection(sourceName) {
      if (sourcesFields.isSourceUnsupported(sourceName)) {
        ModalBus.$emit('open', {
          component: UnsupportedBankPopup,
          props: {
            sourceName,
            bankDisplayName: sourcesFields.getBySourceName(sourceName).displayName,
            waitingListName: sourcesFields.getBySourceName(sourceName).waitingListName,
          },
        });
      } else {
        Segment.trackUserInteraction('BankNameClicked', { sourceName });
        this.setPageParams({ sourceName });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../scss/mixins';

  .bank-selection-flow {

  }
</style>
